import {
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGOUT_USER_REQUEST,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAILURE,
  CHECK_USER_SESSION_SUCCESS,
  CHECK_USER_SESSION_FAILURE,
  CHECK_USER_SESSION_REQUEST,
} from '../actions/user';

import {
  ACTIVATE_CONFIG_FAILURE,
  CONFIGS_SAVE_FAILURE,
} from '../actions/configs';

import {
  IMAGE_UPLOAD_FAILURE,
} from '../actions/images';

const defaultState = {
  username: '',
  email: '',
  sessionToken: '',
  isFetching: false,
  loginError: null,
  isCheckingSession: false,
};

export default (state = defaultState, action) => {
  const { payload = {} } = action;
  const { user, error } = payload;

  switch(action.type) {
    case LOGIN_USER_REQUEST:
      return { ...state, isFetching: true, loginError: null };
    case LOGIN_USER_FAILURE:
      return { ...defaultState, loginError: error };
    case LOGIN_USER_SUCCESS:
      return { ...state, ...user, isFetching: false };
    case LOGOUT_USER_REQUEST:
      return { ...state, isFetching: true };
    case LOGOUT_USER_SUCCESS:
    case LOGOUT_USER_FAILURE:
      return { ...defaultState };
    case CHECK_USER_SESSION_REQUEST:
      return { ...state, isCheckingSession: true };
    case CHECK_USER_SESSION_SUCCESS:
      return { ...state, ...user, isCheckingSession: false };
    case CHECK_USER_SESSION_FAILURE:
      return { ...state, ...defaultState, isCheckingSession: false };

    // Misc write failures that will require re-authentication, typically the
    // uncommon case when a Parse server session has been revoked
    case ACTIVATE_CONFIG_FAILURE:
    case CONFIGS_SAVE_FAILURE:
    case IMAGE_UPLOAD_FAILURE:
      return { ...defaultState };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/user.js